import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  formWrapper: {
    position: 'relative',
    border: `2px solid ${colors.neutral[200]}`,
    borderRadius: '0.6rem',
    padding: '4rem 3rem',
  },
  dependentsForm: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(23rem, 1fr))',
    justifyItems: 'center',
    alignItems: 'start',
    columnGap: '1%',
    rowGap: '2rem',
  },
  actionBtn: {
    width: '23rem',
    minWidth: '15rem',
    marginTop: '2.7rem',
    padding: '0.1rem 1.5rem',
  },
  ssnInput: {
    '& label + p': {
      fontSize: '1.4rem',
    },
  },
  closeEditFormBtn: {
    position: 'absolute',
    right: '1.5rem',
    top: '1.5rem',
    width: '3rem',
    height: '3rem',
  },
};

const createStyles = createUseStyles(styles);

export { createStyles };
